(function () {
	'use strict';
	angular.module('app.leanProjects')
		.controller('editProject', editProject);

	editProject.$inject = ['$scope', '$rootScope', '$stateParams', '$uibModal', '$timeout', '$compile',
		'$location', '$experiments', '$translate', 'editProjectService', 'viewProjectsService', 'newProjectService',
		'leanProjectsService', 'leanProjectAuthService', 'a3ModalService', 'pageTimingService', 'storeService', 'notificationService'
	];

	function editProject($scope, $rootScope, $stateParams, $uibModal, $timeout, $compile, $location,
			$experiments, $translate, editProjectService, viewProjectsService, newProjectService,
			leanProjectsService, leanProjectAuthService, a3ModalService, pageTimingService, storeService, notificationService) {
		var search = $location.search();
		var vm = this;
		var taggedCategoryIndex = -1;
		vm.isSupplierPortal = globalConfig.user.role === 'Supplier';
		var extraQueryParams = $location.search();
		var isApprove = extraQueryParams.approve || 0;
		var isValidate = extraQueryParams.validate || 0;
		var initialLoadDetails = false;
		var initialLoadDocuments = false;
		var initialLoadTab = false;
		var tabIndexes = {
			'tasks': 0,
			'issues': 1,
			'activity': 2,
			'team': 3,
			'metrics': 4,
			'attachment': 5,
			'general': 6
		};

		var linkMap = {
			'kanbanBoard': {
				'label': 'Kanban Board',
				'link': '/application/f/home.html#/lean-projects/projects-kanban/'
			},
			'viewProjects': {
				'label': 'View Projects',
				'link': '/application/f/home.html#/lean-projects/view-projects/'
			},
			'myActiveProjects': {
				'label': 'My Active Projects',
				'link': '/application/f/home.html#/my-assignments'
			},
			'approveProjects': {
				'label': 'Approve Projects',
				'link': '/application/f/home.html#/lean-projects/approve-projects/'
			},
			'myTasks': {
				'label': 'My Tasks',
				'link': '/application/f/home.html#/my-assignments'
			},
			'supplierScorecard': {
				'label': 'Supplier Scorecard',
				'link': '/application/f/home.html#/supply-chain/supplier'
			},
			'supplierProjects': {
				'label': 'Supplier Projects',
				'link': '/application/f/home.html#/supply-chain/supplier-projects/'
			},
			'goalInitiatives': {
				'label': 'Goal Initiatives',
				'link': '/application/f/home.html#/lean-projects/goal-performance'
			},
			'projectSearch': {
				'label': 'Project Search',
				'link': '/application/f/home.html#/lean-projects/project-search?drilldown=1'
			}
		};
		// 24hr after unix epoch, to avoid any timezone issues
		vm.minDate = new Date(86400000);

		vm.fromLocation = {};
		if ($location.search().fromLocation != null) {
			vm.fromLocation = linkMap[$location.search().fromLocation];
			if ($location.search().extraParamKey && $location.search().extraParamValue) {
				var separator;
				if ($location.search().fromLocation === 'projectSearch') {
					separator = '&';
				} else {
					separator = '?';
				}
				vm.fromLocation.link += separator + $location.search().extraParamKey + '=' + $location.search().extraParamValue;
			}
		}

		vm.tableName = extraQueryParams.tableName ? extraQueryParams.tableName : null;
		vm.projectNdx = extraQueryParams.projectNdx ? extraQueryParams.projectNdx : $stateParams.projectNdx;
		vm.insidePanel = extraQueryParams.insidePanel ? extraQueryParams.insidePanel : false;
		vm.leanDirFactoryNdx = extraQueryParams.factoryNdx || globalConfig.factory.id;
		vm.viewTaskNdx = extraQueryParams.taskNdx ? parseInt(extraQueryParams.taskNdx) : 0;
		vm.viewIssueNdx = extraQueryParams.issueNdx ? parseInt(extraQueryParams.issueNdx) : 0;
		vm.activity = [];
		vm.documents = [];
		vm.details = {};
		vm.loading = {
			'activity': true,
			'details': true
		};
		vm.empty = {
			'activity': false
		};
		vm.activeTab = vm.viewIssueNdx !== 0 ? 'issues' : 'tasks';
		var initialTab = vm.activeTab;
		$scope.activeTab = vm.activeTab;
		vm.breadcrumb = false;
		vm.addAttachment = addAttachment;
		vm.updateProjectActivity = updateProjectActivity;
		vm.selectTab = selectTab;
		vm.showEditText = showEditText;
		vm.showEditList = showEditList;
		vm.showEditDate = showEditDate;
		vm.showEditSavings = showEditSavings;
		vm.saveEditList = saveEditList;
		vm.saveEditText = saveEditText;
		vm.saveEditDate = saveEditDate;
		vm.approveProject = approveProject;
		vm.cancelEdit = cancelEdit;
		vm.actionIsAllowed = actionIsAllowed;
		vm.refreshAreaResults = refreshAreaResults;
		vm.projectInCurrentFactory = projectInCurrentFactory;
		vm.dropdownLists = {};
		vm.alignLargeErrorToastMessage = alignLargeErrorToastMessage;
		vm.areaTagTransform = areaTagTransform;
		vm.categoriesTagTransform = categoriesTagTransform;
		vm.isActive = isActive;
		vm.openA3 = openA3;
		vm.openProjectSavingsModal = openProjectSavingsModal;
		vm.showProjectSavingsModal = false;
		vm.editTask = editTask;
		$scope.closeProjectSavings = closeProjectSavings;
		$scope.isOpen = false;
		vm.isAdmin = $rootScope.authz.isAdmin;

		if (vm.isSupplierPortal && !vm.insidePanel) { 
			$timeout(function () {
				jQuery('li.list-group-item.selected').removeClass('selected');
				jQuery('#supplierProjects').addClass('selected');
			}, 0);
		}

		function init() {
			//get activity, get documents, get project details

			vm.initialLoadDetails = false;
			editProjectService.getDetails(vm.projectNdx, vm.leanDirFactoryNdx).then(function (response) {
				if (response && response.status && response.status >= 200 && response.status < 400) {
					vm.targetCurrency = response.data.targetCurrency ? response.data.targetCurrency : globalConfig.browser.currencySymbol;
					vm.projectSavingsType = response.data.projectSavingsType;
					vm.fiscalYear = response.data.fiscalYear;
					vm.details = response.data.project;
					vm.details.status = vm.details.completeFlag && vm.details.stageSequence != 1000 ? 'complete': vm.details.status;
					vm.details.authzInfo = response.data.authzInfo;					
					vm.details.endDate = new Date(vm.details.endDate);
					var dueDateLocal = moment(vm.details.endDate).add(vm.details.endDate.getTimezoneOffset(), 'minutes');
					vm.details.endDate = moment(dueDateLocal)._d;
					vm.details.startDate = new Date(vm.details.startDate);
					var startDateLocal = moment(vm.details.startDate).add(vm.details.startDate.getTimezoneOffset(), 'minutes');
					vm.details.startDate = moment(startDateLocal)._d;
					updateCategoryModel();
					vm.loading.details = false;
					vm.details.isActiveProject = (vm.details.stageSequence !== 1000 && vm.details.stageSequence !== -1);
					vm.isAttachmentTabVisible = globalConfig.user.role !== 'Supplier' || (response.data.project.isSupplierProject && globalConfig.user.role === 'Supplier');

					if (isApprove === '1' && vm.details.stageSequence === -1) {
						approveProject();
					} else if (isValidate === '1' && vm.details.completeFlag !== 1) {
						validateProject();
					}
				} else {
					vm.notFound = true;
				}
				initialLoadDetails = true;
				vm.initialLoadDetails = initialLoadDetails;
				reloadAttachmentsAddPermission();
				reloadTaskAddPermission();
				submitUserTiming();
			});
			vm.loading.details = false;
		}

		function openProjectSavingsModal() {
			vm.showProjectSavingsModal = true;
			$scope.isOpen = true;
		}

		function closeProjectSavings(savingsUpdated) {
			$timeout(function () {
				$scope.isOpen = false;
				vm.showProjectSavingsModal = false;
				if (savingsUpdated) {
					$rootScope.$emit('activityUpdated');
					updateLastModified();
				}
			}, 0);
		}

		function addAttachment(optionNdx) {
			var documentScope = $scope.$new();
			getProjectTasks();
			documentScope.projectNdx = vm.projectNdx;
			documentScope.leanDirFactoryNdx = vm.leanDirFactoryNdx;
			documentScope.tasks = [];
			documentScope.upload = {
				currentOption: optionNdx || -1
			};
			var opts = {
				scope: documentScope,
				templateUrl: '/application/f/lean-projects/projects/document-upload.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			documentScope.close = function () {
				instance.close();
				documentScope.$destroy();
			};

			documentScope.ok = function (files) {
				if (files) {
					var isInitUploadAttachmentsTab = vm.activeTab === 'attachment';
					for (var i = 0; i < files.length; i++) {
						// Upload File
						(function(index) {
							editProjectService.uploadDocuments(vm.projectNdx, vm.leanDirFactoryNdx, files[index], documentScope.upload.currentOption).then(function (response) {
								vm.selectTab('attachment');
								instance.close();
								documentScope.$destroy();
								if (index === files.length - 1) {
									if (isInitUploadAttachmentsTab) {
										reloadAttachments();
									}
									$rootScope.$emit('toast', {
										'message': response.message,
										'success': response.isSuccessful
									});
									$rootScope.$emit('activityUpdated');
								}
							});
						})(i);
					}
				}
			};

			function getProjectTasks() {
				var tasksToUploadDocuments = [{
					type: 'project',
					ndx: -1,
					name: vm.details.name
				}];
				editProjectService.getTasks(vm.projectNdx, vm.leanDirFactoryNdx).then(function(tasks) {
					if (tasks && tasks.length > 0) {
						tasks = _.sortBy(tasks, 'name');
						angular.forEach(tasks, function(task) {
							if (leanProjectAuthService.actionIsAllowed('editTask', vm.details, task.taskResponsibleId)) {
								task.type = 'task';
								tasksToUploadDocuments.push(task);
							}
						});
					}
					documentScope.tasks = tasksToUploadDocuments;
				});
			}
		}

		function projectInCurrentFactory() {
			return (globalConfig.factory.id === vm.details.leanDirFactoryNdx);
		}

		function selectTab(tabName) {
			vm.activeTabIndex = tabIndexes[tabName];
			vm.activeTab = tabName;
			$scope.activeTab = tabName;
			cancelEdit();
		}

		function alignLargeErrorToastMessage(message) {
			var screenWidth = screen.width;
			var toastMessageWidth = message.length * (13 / 2);
			var remaingWidth = (((screenWidth - toastMessageWidth) / 2) / screenWidth) * 100;
			return {
				left: remaingWidth + '%'
			};
		}

		function showEditList(field, fieldId, label, id, display, taggable, multiSelect) {
			loadList(field);
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#details-' + field);
			var pos = cell.offset();
			var editTemplate;
			if (taggable && leanProjectAuthService.actionIsAllowed('addTag', vm.details) && leanProjectAuthService.actionIsAllowed('editArea', vm.details) && vm.isAdmin) {
				editTemplate = getTagListTemplate(pos, field, fieldId, label, id, display, multiSelect);
			} else {
				editTemplate = getListTemplate(pos, field, fieldId, label, id, display, multiSelect);
			}
			vm.modelName = vm.details[fieldId];
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('#mainView .embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				if (code === 27) {
					vm.cancelEdit();
				}
			});
			jQuery('.inlineEditDiv input').focus();
			vm.inlineActive = true;
		}

		function showEditDate(field, label) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#details-' + field);
			var pos = cell.offset();
			var content = vm.details[field];
			var editTemplate = getDateTemplate(pos, field, label);
			vm.currentDate = content;
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('#mainView .embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				if (code === 13) {
					vm.saveEditDate(field, label);
				} else if (code === 27) {
					vm.cancelEdit();
				}
			});
			jQuery('.inlineEditDiv input').focus();
			vm.inlineActive = true;
		}

		function showEditText(field, label, maxLength, allowBlank) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			allowBlank = typeof allowBlank !== 'undefined' ? allowBlank : true;
			var cell = jQuery('.details-' + field);
			var pos = cell.offset();
			var content = vm.details[field];
			var editTemplate = getTextTemplate(pos, field, label, maxLength, allowBlank);
			vm.currentText = _.unescape(content);
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('#mainView .embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				if (code === 13) {
					if (!allowBlank && vm.currentText.length == 0) {
						return;
					}
					vm.saveEditText(field, label);
				} else if (code === 27) {
					vm.cancelEdit();
				}
			});
			jQuery('.inlineEditDiv input').focus();
			vm.inlineActive = true;
		}

		function showEditSavings(field, label) {
			$scope.savingsType = field === 'targetSavings' ? 'Target' : 'Actual';
			openProjectSavingsModal();
			return;
		}

		function getTextTemplate(position, field, label, maxLength, allowBlank) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (position.left + 296 > windowWidth) {
				position.left = position.left - (position.left + 296 - windowWidth - 8);
			}
			if (position.top + 112 > windowHeight) {
				position.top = position.top - (position.top + 112 - windowHeight - 8);
			}
			var editTemplate = '<div class="inlineEditDiv textEdit" style="top:' + position.top + 'px; left: ' +
				position.left + 'px;"><div class="inlineEditHeader">{{\'Edit ' + label + '\' | translate}}</div>' +
				'<div class="input-holder-with-clear">' +
				'<input class="inlineEditInput with-clear" ng-model="editProjectController.currentText" />' +
				'<span class="input-clear" ng-show="editProjectController.currentText && editProjectController.currentText.length" ng-click="editProjectController.currentText = \'\'"><i class="fa fa-times"></i></span>' +
				'</div>' +
				(typeof maxLength !== 'undefined' ? '<span class="error-desc" ng-if="editProjectController.currentText.length>' + maxLength + '">Max allowed characters are ' + maxLength + '.</span>' : '') +
				'<div class="inlineEditButtons"><a class="button flat" ng-click="editProjectController.cancelEdit()">{{\'Cancel\' | translate}}</a>' +
				'<a class="button flat colored" ng-click="' +
					(typeof maxLength !== 'undefined' ? '!(editProjectController.currentText.length>' + maxLength + ') && ' : '') +
					(!allowBlank ? ' (editProjectController.currentText.length > 0) && ' : '') +
				' editProjectController.saveEditText(\'' + field + '\', \'' + label + '\')">{{\'Save\' | translate}}</a></div></div>';
			return editTemplate;
		}

		function getTagListTemplate(position, field, fieldId, label, id, display, multiSelect) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (position.left + 340 > windowWidth) {
				position.left = position.left - (position.left + 340 - windowWidth - 8);
			}
			if (position.top + 356 > windowHeight) {
				position.top = position.top - (position.top + 356 - windowHeight - 8);
			}

			var multiSelectStr = (multiSelect ? 'multiple' : '');
			var uiSelectMatchTerm = (multiSelect ? '<span ng-bind-html="$item.name + ($item.status === \'Archive\' ? \' (archived)\': \'\')"></span>' : '<span ng-bind-html="$select.selected.' + display + '"></span>');
			var className = multiSelect ? 'multiselect-edit' : 'textEdit';

			var editTemplate = '<div ng-click="$event.preventDefault();" class="inlineEditDiv ' + className + '" style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
				'<div class="inlineEditHeader"><span translate>Choose ' + label + '</span></div>' +
				'<ui-select ' + multiSelectStr + ' tagging="editProjectController.' + field + 'TagTransform" append-to-body="true" theme="bootstrap" ng-model="editProjectController.modelName">' +
				'<ui-select-match placeholder="{{\'' + 'Select ' + label + '...\'' + ' | translate}}">' +
				uiSelectMatchTerm +
				'</ui-select-match>';

			if (multiSelect) {
				editTemplate += '<ui-select-choices ui-disable-choice="item.status === \'Archive\'" repeat="item.' + id + ' as item  in editProjectController.dropdownLists.' + field + ' | filter: $select.search">' +
					'<div ng-if="item.isTag"><span ng-bind-html="item.' + display + '"></span><span translate>(Click or press Enter to create)</span></div>' +
					'<div ng-if="!item.isTag"><span ng-bind-html="item.' + display + '"></span></div>' +
					'</ui-select-choices>' +
					'</ui-select>';
			} else {
				editTemplate += '<ui-select-choices ui-disable-choice="item.status === \'Archive\'" repeat="item.' + id + ' as item in editProjectController.dropdownLists.' + field + ' | filter: $select.search" refresh="editProjectController.refreshAreaResults($select)" refresh-delay="0">' +
					'<div ng-bind-html="item.' + display + ' + item.extraLabel"></div>' +
					'</ui-select-choices>' +
					'</ui-select>';
			}
			editTemplate += '<div class="inlineEditButtons">' +
				'<button class="button flat" ng-click="editProjectController.cancelEdit()">{{\'Cancel\'| translate}}</button>' +
				'<button class="button flat colored" ng-click="editProjectController.saveEditList(\'' + field + '\', \'' + fieldId + '\', \'' + label + '\', \'' + id + '\', \'' + display + '\')">{{\'Save\'| translate}}</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}

		function getListTemplate(position, field, fieldId, label, id, display, multiSelect) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (position.left + 340 > windowWidth) {
				position.left = position.left - (position.left + 340 - windowWidth - 8);
			}
			if (position.top + 356 > windowHeight) {
				position.top = position.top - (position.top + 356 - windowHeight - 8);
			}

			var multiSelectStr = (multiSelect ? ' multiple ' : '');
			var uiSelectMatchTerm = (multiSelect ? '{{$item.name}}' : '{{$select.selected.' + display + ' | translate}}');
			var className = multiSelect ? 'multiselect-edit' : 'textEdit';

			var editTemplate = '<div ng-click="$event.preventDefault();" class="inlineEditDiv ' + className + '" style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
				'<div class="inlineEditHeader"><span translate>Choose ' + label + '</span></div>' +
				'<ui-select ' + multiSelectStr + 'append-to-body="true" theme="bootstrap" ng-model="editProjectController.modelName">' +
				'<ui-select-match placeholder="{{\'' + 'Select ' + label + '...\'' + ' | translate}}">' +
				uiSelectMatchTerm +
				'</ui-select-match>' +
				'<ui-select-choices repeat="item.' + id + ' as item in editProjectController.dropdownLists.' + field + ' | filter: $select.search">' +
				'<div>{{item.' + display + ' | translate}}</div>' +
				'</ui-select-choices>' +
				'</ui-select>' +
				'<div class="inlineEditButtons">' +
				'<button class="button flat" ng-click="editProjectController.cancelEdit()">{{\'Cancel\' | translate }}</button>' +
				'<button class="button flat colored" ng-click="editProjectController.saveEditList(\'' + field + '\', \'' + fieldId + '\', \'' + label + '\', \'' + id + '\', \'' + display + '\')">{{\'Save\' | translate }}</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}

		function getDateTemplate(position, field, label) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (position.left + 340 > windowWidth) {
				position.left = position.left - (position.left + 340 - windowWidth - 8);
			}
			if (position.top + 356 > windowHeight) {
				position.top = position.top - (position.top + 356 - windowHeight - 8);
			}
			var editTemplate = '<div class="inlineEditDiv dateEdit" style="top:' + position.top + 'px; left: ' +
				position.left + 'px;"><div class="inlineEditHeader">' + '<span translate>Choose a ' + label + '</span></div>' +
				'<div uib-datepicker ng-model="editProjectController.currentDate" min-date="editProjectController.minDate" class="well well-sm"></div>' +
				'<div class="inlineEditButtons">' +
				'<a class="button flat" ng-click="editProjectController.cancelEdit()">{{\'Cancel\' | translate }}</a>' +
				'<a class="button flat colored" ng-click="editProjectController.saveEditDate(\'' + field + '\'' + ', \'' + label + '\')">{{\'Save\' | translate }}</a></div></div>';
			return editTemplate;
		}

		function saveEditList(field, fieldId, label, id, display, taggable, multiselect) {
			var saveObj = {};
			saveObj.id = vm.projectNdx;
			var changeMade = false;
			if (field == 'categories') {
				saveObj.categoryIds = [];
				saveObj.newCategories = [];
				angular.forEach(vm.modelName, function (categoryId) {
					if (('' + categoryId).indexOf('tag-') !== 0) {
						saveObj.categoryIds.push(categoryId);
					} else {
						saveObj.newCategories.push(categoryId.substring(4));
					}
				});
				changeMade = !_.isEqual(vm.modelName.sort(), vm.details[fieldId].sort());
			} else if (field == 'area') {
				if (('' + vm.modelName).indexOf('tag-') !== 0) {
					saveObj.areaNdx = vm.modelName;
				} else {
					saveObj.newArea = vm.modelName.substring(4);
				}
				changeMade = vm.modelName !== vm.details[fieldId];
			} else {
				saveObj[fieldId] = vm.modelName;
				changeMade = vm.modelName !== vm.details[fieldId];
			}

			if (changeMade) {
				viewProjectsService.saveProject(saveObj, vm.leanDirFactoryNdx, (new Date(vm.details.lastModified)).toUTCString())
					.then(function (response) {
						if (response && response.status && response.status >= 200 && response.status < 400) {
							var updateMessage = (fieldId === 'projectManagerId' ? '' : 'Project ');
							$rootScope.$emit('toast', {
								'message': updateMessage + label + ' was saved successfully',
								'success': true
							});
							$rootScope.$emit('activityUpdated');
							if (fieldId === 'projectManagerId') {
								$scope.$broadcast('projectManagerChanged', {projectManagerId: vm.modelName});
								$scope.$emit('projectManagerChanged', {projectId: vm.details.id, projectManagerId: vm.modelName});
							}
							if (field === 'categories') {
								loadList(field, updateCategoryModelAfterSave);
							} else if (field === 'area') {
								loadList(field, updateAreaModelAfterSave);
							} else {
								var listObject = '';
								angular.forEach(vm.dropdownLists[field], function (obj) {
									if (obj[id] === vm.modelName) {
										vm.details[field] = obj[display];
										listObject = obj;
									}
								});
								vm.details[fieldId] = vm.modelName;
								if (field === 'stage') {
									vm.details.stageSequence = listObject.stageSequence;
									if (vm.activeTab === 'attachment') {
										reloadAttachments();
										reloadAttachmentsAddPermission();
									}
									if (vm.activeTab === 'tasks') {
										reloadTaskAddPermission();
										reloadTasks();
									}
								}
								vm.modelName = '';
							}
							updateLastModified();
						} else if (response && response.status === 412) {
							var errorMessage = 'This project has been updated since you last loaded the page, please refresh the page';
							if (response && response.data && response.data.error) {
								errorMessage = response.data.error;
							}
							$rootScope.$emit('toast', {
								'message': errorMessage,
								'success': false
							});
						} else {
							$rootScope.$emit('toast', {
								'message': 'Unexpected server error',
								'success': false
							});
						}
					});
			}
			cancelEdit(true);
		}

		function saveEditText(field, label) {
			var saveObj = {};
			saveObj.id = vm.projectNdx;
			saveObj[field] = vm.currentText;
			if (vm.currentText !== vm.details[field]) {
				viewProjectsService.saveProject(saveObj, vm.leanDirFactoryNdx, (new Date(vm.details.lastModified)).toUTCString())
					.then(function (response) {
						if (response && response.status && response.status >= 200 && response.status < 400) {
							$rootScope.$emit('toast', {
								'message': 'Project ' + label + ' was saved successfully',
								'success': true
							});
							$rootScope.$emit('activityUpdated');
							vm.details[field] = vm.currentText;
							vm.currentText = '';
							updateLastModified();
						} else if (response && response.status === 412) {
							var errorMessage = 'This project has been updated since you last loaded the page, please refresh the page';
							if (response && response.data && response.data.error) {
								errorMessage = response.data.error;
							}
							$rootScope.$emit('toast', {
								'message': errorMessage,
								'success': false
							});
						} else {
							$rootScope.$emit('toast', {
								'message': (response.errorMessage ? response.errorMessage : 'Unexpected server error'),
								'success': false
							});
						}
					});
			}
			cancelEdit(true);
		}

		function saveEditDate(field, label) {
			var saveObj = {};
			var currentDateUtc = moment(vm.currentDate).subtract(vm.currentDate.getTimezoneOffset(), 'minutes');
			vm.currentDate = moment(vm.currentDate)._d;
			saveObj.id = vm.projectNdx;
			saveObj[field] = moment(currentDateUtc)._d;
			if (!moment(vm.currentDate).isSame(vm.details[field])) {
				viewProjectsService.saveProject(saveObj, vm.leanDirFactoryNdx, (new Date(vm.details.lastModified)).toUTCString())
					.then(function (response) {
						if (response && response.status && response.status >= 200 && response.status < 400) {
							$rootScope.$emit('toast', {
								'message': label + ' was saved successfully',
								'success': true
							});
							$rootScope.$emit('activityUpdated');
							vm.details[field] = vm.currentDate;
							vm.currentDate = '';
							updateLastModified();
						} else if (response && response.status === 412) {
							var errorMessage = 'This project has been updated since you last loaded the page, please refresh the page';
							if (response && response.data && response.data.error) {
								errorMessage = response.data.error;
							}
							$rootScope.$emit('toast', {
								'message': errorMessage,
								'success': false
							});
						} else {
							$rootScope.$emit('toast', {
								'message': 'Unexpected server error',
								'success': false
							});
						}
					});
			}
			cancelEdit(true);
		}

		function cancelEdit(notClearInputs) {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.inlineActive = false;

			if (!notClearInputs) {
				vm.modelName = undefined;
				vm.currentText = '';
				vm.currentDate = undefined;
			}

			if ($scope.$$childTail.$selectMultiple) {
				// destroy multiselects if exists
				delete $scope.$$childTail.$select;
				delete $scope.$$childTail.$selectMultiple;
			}
		}

		// This is not working, due to a problem with the ui-select.
		// A workaround is to use the refreshAreaResults function instead.
		// Leaving code here in case this ever gets fixed in ui-select
		function areaTagTransform(newTag) {
			var item = {
				'projectArea': newTag,
				'areaNdx': 'tag-' + newTag
			};
			return item;
		}

		function categoriesTagTransform(newTag) {
			var item = {
				'name': newTag,
				'id': 'tag-' + newTag
			};
			return item;
		}

		function updateAreaModelAfterSave() {
			var selectedAreaIndex;
			if (('' + vm.modelName).indexOf('tag-') !== 0) {
				selectedAreaIndex = findInArray(vm.dropdownLists.area, 'areaNdx', vm.modelName);
			} else {
				selectedAreaIndex = findInArray(vm.dropdownLists.area, 'projectArea', vm.modelName.substring(4));
			}
			vm.details.area = vm.dropdownLists.area[selectedAreaIndex].projectArea;
			vm.details.areaNdx = vm.dropdownLists.area[selectedAreaIndex].areaNdx;
			$scope.$emit('projectAreaChanged', {projectId: vm.details.id, projectArea: vm.details.area});
		}

		function updateCategoryModelAfterSave() {
			var idList = [];
			var i, catIndex;
			for (i = 0; i < vm.modelName.length; i++) {
				if (('' + vm.modelName[i]).indexOf('tag-') !== 0) {
					idList.push(vm.modelName[i]);
				} else {
					catIndex = findInArray(vm.dropdownLists.categories, 'name', vm.modelName[i].substring(4));
					if (catIndex || catIndex === 0) {
						idList.push(vm.dropdownLists.categories[catIndex].id);
					}
				}
			}
			vm.details.categoryIds = idList;
			vm.modelName = undefined;
			var categories = [];
			for (i = 0; i < vm.details.categoryIds.length; i++) {
				catIndex = findInArray(vm.dropdownLists.categories, 'id', vm.details.categoryIds[i]);
				if (catIndex || catIndex === 0) {
					categories.push(vm.dropdownLists.categories[catIndex]);
				}
			}
			vm.details.categories = categories;
			updateCategoryModel();
		}

		function loadList(type, callback) {
			if (vm.dropdownLists[type] && vm.dropdownLists[type].length && type !== 'area' && type !== 'categories') {
				return;
			} else {
				switch (type) {
				case 'projectManager':
					newProjectService.getUsers(vm.leanDirFactoryNdx, vm.details.projectManagerId, true).then(function (users) {
						vm.dropdownLists[type] = users;
					});
					break;
				case 'stage':
					leanProjectsService.getStages(vm.leanDirFactoryNdx).then(function (stages) {
						vm.dropdownLists[type] = stages;
					});
					break;
				case 'area':
					editProjectService.getAreas(vm.leanDirFactoryNdx, true).then(function (areas) {
						if (!areas || !areas.length) {
							areas = [];
						}
						for (var i = 0; i < areas.length; i++) {
							areas[i].projectArea = _.unescape(strip(areas[i].projectArea));
						}
						vm.dropdownLists[type] = areas;
						if (callback) {
							callback();
						}
					});
					break;
				case 'categories':
					editProjectService.getCategories(vm.leanDirFactoryNdx).then(function (categories) {
						if (categories && categories.length) {
							categories = categories.map(function (category) {
								var transformedCategory = {};
								transformedCategory.name = category.projectCategoryName;
								transformedCategory.id = category.projectCategoryId;
								transformedCategory.status = category.status;
								return transformedCategory;
							});
						} else {
							categories = [];
						}
						vm.dropdownLists[type] = categories;
						if (callback) {
							callback();
						}
					});
					break;
				}
			}
		}

		function actionIsAllowed(action) {
			return leanProjectAuthService.actionIsAllowed(action, vm.details);
		}

		function updateCategoryModel() {
			vm.details.categoryNames = '';
			vm.details.categoryIds = [];
			angular.forEach(vm.details.categories, function (category) {
				vm.details.categoryNames += strip(category.name) + ', ';
				vm.details.categoryIds.push(category.id);
			});
			if (vm.details.categoryNames.length > 2) {
				vm.details.categoryNames = vm.details.categoryNames.substring(0, vm.details.categoryNames.length - 2);
			}
		}

		function approveProject() {
			leanProjectsService.getStages(vm.leanDirFactoryNdx).then(function (stages) {
				var projectStages = stages;
				saveProject(projectStages[1], 'approved', 'approve this project', $translate.instant('Approve'));
			});
		}

		function saveProject(stageObj, action, additionalText, buttonText) {
			var confirmScope = $scope.$new();
			confirmScope.additionalText = additionalText;
			confirmScope.buttonText = buttonText;
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function () {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function () {
				instance.close();
				confirmScope.$destroy();
				var projObj = {};
				projObj.id = vm.projectNdx;
				projObj.stageId = stageObj.id;
				projObj.stageSequence = stageObj.stageSequence;
				viewProjectsService.saveProject(projObj, vm.leanDirFactoryNdx, (new Date(vm.details.lastModified)).toUTCString())
					.then(function (response) {
						if (response && response.status && response.status >= 200 && response.status < 400) {
							var reloadTasksGrid = vm.details.stageSequence === -1 && stageObj.stageSequence !== -1;
							vm.details.stageId = stageObj.id;
							vm.details.stageSequence = stageObj.stageSequence;
							vm.details.stage = stageObj.name;

							updateLastModified(reloadTasksGrid);
							$rootScope.$emit('toast', {
								'message': 'Project ' + action + ' successfully',
								'success': true
							});
							$rootScope.$emit('activityUpdated');
							if (reloadTasksGrid) {
								$rootScope.$emit('reloadTasks');
							}
						} else if (response && response.status == 412) {
							var errorMessage = 'This project has been updated since you loaded the page, please refresh the page';
							if (response && response.data && response.data.error) {
								errorMessage = response.data.error;
							}
							$rootScope.$emit('toast', {
								'message': errorMessage,
								'success': false
							});
						} else {
							$rootScope.$emit('toast', {
								'message': 'Unexpected server error',
								'success': false
							});
						}
					});
			};
		}

		function refreshAreaResults($select) {
			var search = $select.search,
				list = angular.copy($select.items),
				FLAG = -1;
			//remove last user input
			list = list.filter(function (item) {
				return item.id !== FLAG;
			});

			if (!search) {
				//use the predefined list
				$select.items = list;
			} else {
				//manually add user input and set selection
				var userInputItem = {
					id: FLAG,
					projectArea: search,
					areaNdx: 'tag-' + search,
					extraLabel: ' (Click or press Enter to create)'
				};
				$select.items = [userInputItem].concat(list);
				$select.selected = $select.items[0];
				$select.activeIndex = 0;
				$select.activate($select.items[0]);
			}
		}

		function validateProject() {
			var confirmScope = $scope.$new();
			confirmScope.additionalText = 'validate this project';
			confirmScope.buttonText = 'VALIDATE';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function () {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function () {
				instance.close();
				confirmScope.$destroy();
				var projObj = {};
				projObj.id = vm.projectNdx;
				projObj.completeFlag = 1;
				viewProjectsService.saveProject(projObj, vm.leanDirFactoryNdx, (new Date(vm.details.lastModified)).toUTCString())
					.then(function (response) {
						if (response && response.status && response.status >= 200 && response.status < 400) {
							vm.details.completeFlag = 1;
							updateLastModified();
							$rootScope.$emit('toast', {
								'message': 'Project validated successfully',
								'success': true
							});
							$rootScope.$emit('activityUpdated');
						} else if (response && response.status === 412) {
							var errorMessage = 'This project has been updated since you loaded the page, please refresh the page';
							if (response && response.data && response.data.error) {
								errorMessage = response.data.error;
							}
							$rootScope.$emit('toast', {
								'message': errorMessage,
								'success': false
							});
						} else {
							$rootScope.$emit('toast', {
								'message': 'Unexpected server error',
								'success': false
							});
						}
					});
			};
		}

		function updateLastModified(updateProjectDates) {
			if ($scope.fromMyWorkTab || $rootScope.fromMyWorkTab || vm.tableName) {
				notificationService.getUnreadInventoryActions(true);
				storeService.dispatch(storeService.actionCreators.myProjectTasks.getMyProjectTasks(
					{ assignee: globalConfig.user.id, tableName: vm.tableName }));
			}
			editProjectService.getDetails(vm.projectNdx, vm.leanDirFactoryNdx).then(function (response) {
				if (response && response.data && response.data.project) {
					vm.details.lastModified = response.data.project.lastModified;
					vm.details.status = response.data.project.completeFlag && response.data.project.stageSequence != 1000 ? 'complete': response.data.project.status;
					vm.details.ytdTargetSavings = response.data.project.ytdTargetSavings;
					vm.details.ytdActualSavings = response.data.project.ytdActualSavings;
					vm.details.categories = response.data.project.categories;
					vm.details.savingsStartYear = response.data.project.savingsStartYear;
					vm.savingsStartYear = response.data.project.savingsStartYear;
					vm.details.isActiveProject = vm.details.stageSequence !== 1000 && vm.details.stageSequence !== -1;

					if (updateProjectDates) {
						var endDate = new Date(response.data.project.endDate);
						var dueDateLocal = moment(endDate).add(endDate.getTimezoneOffset(), 'minutes');
						vm.details.endDate = moment(dueDateLocal)._d;
						var startDate = new Date(response.data.project.startDate);
						var startDateLocal = moment(startDate).add(startDate.getTimezoneOffset(), 'minutes');
						vm.details.startDate = moment(startDateLocal)._d;
					}
					vm.details.targetBenefitDescription = response.data.project.targetBenefitDescription;
					vm.details.actualBenefitDescription = response.data.project.actualBenefitDescription;

					updateCategoryModel();
				}
			});
		}

		function isActive(tab) {
			return vm.activeTab === tab;
		}

		function openA3(projNdx) {
			var modalInstance = a3ModalService.openModal(projNdx, vm.leanDirFactoryNdx);

			modalInstance.result.finally(function () {
				a3ModalService.removeNoPrintClass();
			});
		}

		var lastModifiedListener = $rootScope.$on('updateLastModified', function (event, args) {
			var dueDateChanged = false;
			if (args && args['dueDateChange']) {
				dueDateChanged = args['dueDateChange'];
			}
			updateLastModified(dueDateChanged);
		});

		var initialTabLoadedListener = $scope.$on(initialTab + 'Loaded', function() {
			initialLoadTab = true;
			submitUserTiming();
		});

		function submitUserTiming() {
			if (initialLoadDetails && initialLoadDocuments && initialLoadTab) {
				$timeout(function() {
					pageTimingService.submitUserTiming('Edit Project');
				});
			}
		}

		function updateProjectActivity() {
			$rootScope.$emit('activityUpdated');
		}

		function reloadAttachments() {
			var tableName = 'project-attachments';
			var fetchDataProps = {
				tableName: tableName,
				initialLoad: true
			};
			storeService.dispatch(storeService.actionCreators.resetDataForTable(tableName));
			storeService.dispatch(storeService.actionCreators.fetchReportData(fetchDataProps));
		}

		function reloadTasks() {
			var tableName = 'projecttasks';
			var fetchDataProps = {
				tableName: tableName,
				initialLoad: true,
				fetchDataCallback: function (tableData) {
					tableData.rows.data.forEach(function (row) {
						if (actionIsAllowed('editTask', row.taskResponsibleId)) {
							row.canDeleteTask = true;
							row.hasCheckBox = true;
							row.checkbox = false;
							row.selected = false;
						}
					});
					return tableData;
				}
			};
			storeService.dispatch(storeService.actionCreators.resetDataForTable(tableName));
			storeService.dispatch(storeService.actionCreators.fetchReportData(fetchDataProps));
		}

		function reloadAttachmentsAddPermission() {
			storeService.dispatch(storeService.actionCreators.setAddAttachmentAllowed(actionIsAllowed('addAttachment')));
		}

		function reloadTaskAddPermission() {
			storeService.dispatch(storeService.actionCreators.setAddTaskAllowed(actionIsAllowed('addTask')));
		}

		function editTask(task) {
			var taskFormScope = $rootScope.$new();
			taskFormScope.task = jQuery.extend({}, task);
			taskFormScope.action = 'Edit';
			taskFormScope.viewMode = !actionIsAllowed('editTask', task.taskResponsibleId);
			taskFormScope.projectNdx = vm.projectNdx;
			taskFormScope.leanDirFactoryNdx = vm.leanDirFactoryNdx;
			taskFormScope.details = vm.details;
			var opts = {
				scope: taskFormScope,
				templateUrl: '/application/f/lean-projects/projects/task-form/task-form.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			taskFormScope.closeDialog = function() {
				instance.close();
				taskFormScope.$destroy();
			};

			taskFormScope.result = function(message, isSuccessful) {
				$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
				if (isSuccessful && message != '') {
					updateProjectActivity();
					reloadAttachments();
				}
				if (isSuccessful || message == '') {
					instance.close();
					taskFormScope.$destroy();
				}
			};
		}
		
		var addNewAttachment = $scope.$on('addAttachment', function (event, args) {
			var taskNdx = undefined;
			if (args && args['taskNdx']) {
				taskNdx = args['taskNdx'];
			}
			addAttachment(taskNdx);
		});

		var goToAttachment = $scope.$on('goToAttachment', function (event, args) {
			$timeout(function () {
				vm.selectTab('attachment');
			});
		});

		$scope.$on('$destroy', lastModifiedListener);
		$scope.$on('$destroy', initialTabLoadedListener);
		$scope.$on('$destroy', addNewAttachment);
		$scope.$on('$destroy', goToAttachment);

		init();
	}
})();
